import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { IFilter, INotificacion, IQueryParam } from 'modelos/src';
import { Subscription } from 'rxjs';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { NotificacionesService } from '../service';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import {
  fechaCelda,
  haceCelda,
} from '../../../../auxiliares/tabla/celdas';

@Component({
  selector: 'app-listado-notificaciones',
  templateUrl: './listado-notificaciones.component.html',
  styleUrls: ['./listado-notificaciones.component.scss'],
  standalone: false,
})
export class ListadoNotificacionesComponent implements OnInit, OnDestroy {
  helper = inject(HelperService);
  private notificacionesService = inject(NotificacionesService);
  private lista2 = inject(Lista2Service);
  private dialog = inject(DialogService);
  private service = inject(NotificacionesService);

  public verLeidas = false;
  public mostrarConfig = false;

  public totalCount = 0;
  public notificaciones: INotificacion[] = [];

  //
  private filter: IFilter<INotificacion> = { leido: false };
  public queryParams: IQueryParam = {
    page: 0,
    limit: 10,
    sort: '-fechaCreacion',
    filter: JSON.stringify(this.filter),
  };

  // Listado Continuo
  public datos$?: Subscription;

  public async toggleVerTodas(): Promise<void> {
    this.notificaciones = [];
    this.totalCount = 0;
    this.verLeidas = !this.verLeidas;
    this.filter['leido'] = this.verLeidas ? true : false;
    this.queryParams.filter = JSON.stringify(this.filter);
    await this.listar();
  }

  public async marcarTodasComoLeidas() {
    const confirm = await this.dialog.confirm(
      'Confirmá la acción',
      `¿Querés marcar todas las notificaciones como leídas?`,
    );
    if (confirm) {
      try {
        await this.service.marcarTodasComoLeidas();
      } catch (error) {
        this.helper.notifError(error);
      }
    }
  }

  // Fechas: dd/MM/yyyy HH:mm (24 h, huso del navegador) y "hace x"
  public fecha = fechaCelda;
  public hace = haceCelda;

  public verTodasLeidas(): void {
    this.dialog.notificacionesLeidas();
  }

  //

  public toggleConfig() {
    this.mostrarConfig = !this.mostrarConfig;
  }

  public async marcarComoLeida(notificacion: INotificacion): Promise<void> {
    try {
      await this.notificacionesService.marcarComoLeida(notificacion._id!);
      notificacion.leido = true;
      await this.listar();
    } catch (error) {
      this.helper.notifError(error);
    }
  }

  public async marcarComoNoLeida(notificacion: INotificacion): Promise<void> {
    try {
      await this.notificacionesService.marcarComoNoLeida(notificacion._id!);
      notificacion.leido = false;
      await this.listar();
    } catch (error) {
      this.helper.notifError(error);
    }
  }

  public async eliminar(notificacion: INotificacion): Promise<void> {
    try {
      await this.notificacionesService.delete(notificacion._id!);
      this.notificaciones = this.notificaciones.filter(
        (n) => n._id !== notificacion._id,
      );
      await this.listar();
    } catch (error) {
      this.helper.notifError(error);
    }
  }

  private async listar(): Promise<void> {
    try {
      this.datos$?.unsubscribe();
      this.datos$ = this.lista2
        .notificacions(this.queryParams, 30)
        .subscribe((data) => {
          this.totalCount = data.totalCount;
          this.notificaciones = data.datos;
        });
    } catch (error) {
      this.helper.notifError(error);
    }
  }

  //

  async ngOnInit(): Promise<void> {
    await this.listar();
  }

  ngOnDestroy(): void {
    this.datos$?.unsubscribe();
  }
}
